export default __webpack_public_path__ + "static/media/detail_big_10_3.e69090a9.jpg";